import { Component, signal, inject, HostListener, ElementRef } from '@angular/core';
// Force TS server refresh
import { AsyncPipe, NgClass } from '@angular/common';
import { LucideAngularModule, KeyRound, LogOut } from 'lucide-angular';

import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [NgClass, LucideAngularModule, AsyncPipe],
  templateUrl: './user-avatar.component.html'
})
export class UserAvatarComponent {
  readonly authService = inject(AuthService);
  private readonly elementRef = inject(ElementRef);

  isOpen = signal(false);
  isChangingPassword = signal(false);

  readonly KeyRound = KeyRound;
  readonly LogOut = LogOut;

  getUserInitials(user: { name?: string; email?: string } | null | undefined): string {
    if (!user) return 'U';
    const name = user.name ?? user.email ?? 'U';
    const parts = name.trim().split(' ');
    const first = parts[0]?.charAt(0).toUpperCase() ?? '';
    const second = parts[1]?.charAt(0).toUpperCase() ?? '';
    return first + second;
  }

  toggleDropdown() {
    this.isOpen.update(v => !v);
  }

  @HostListener('document:click', ['$event.target'])
  closeOnOutsideClick(target: EventTarget | null) {
    if (!target || this.elementRef.nativeElement.contains(target as Node)) return;
    this.isOpen.set(false);
  }

  async handleChangePassword(userEmail: string | undefined) {
    if (!userEmail) {
      console.error('No se encontró un correo electrónico asociado a tu cuenta.');
      return;
    }

    try {
      this.isChangingPassword.set(true);
      // Mock call: await authService.triggerPasswordReset(userEmail);
      await new Promise(resolve => setTimeout(resolve, 1500));
      console.log('Hemos enviado un enlace para restablecer tu contraseña a tu correo electrónico.');
      this.isOpen.set(false);
    } catch (error) {
      console.error('Error triggering password reset:', error);
    } finally {
      this.isChangingPassword.set(false);
    }
  }

  handleLogout() {
    this.authService.logout();
  }
}
